import { render, staticRenderFns } from "./OfficeStaffEditPage.vue?vue&type=template&id=9cf71220&"
import script from "./OfficeStaffEditPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeStaffEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports